import angular from 'angular';
import FiltersService from './filters.service.js';
import FiltersSchema from './filters.schema';

let filtersModule = angular.module('filters', [])

    .service('FiltersService', FiltersService)
    .constant('FiltersSchema', FiltersSchema)
    .name;

export default filtersModule;
